import AdaptationTag from "@/components/display/AdaptationTag";
import { AdaptationType } from "@/types/adaptation";
import CloseCircleFilled from "@ant-design/icons/es/icons/CloseCircleFilled";
import { CaretDownIcon } from "@phosphor-icons/react/dist/ssr";
import { Button, ConfigProvider, Select } from "antd";
import { PathwayWithActions } from "../hooks/useAutoAdaptationPathways";
const PathwaySelector = ({
  pathways,
  handleSelect,
  value,
  placeholder = "Select a pathway",
  allowClear = true
}: {
  pathways: (Partial<PathwayWithActions> & {
    id: string;
    adaptation_type: AdaptationType;
  })[];
  handleSelect: (pathwayId: string | null) => void;
  value?: string | null;
  placeholder?: string;
  allowClear?: boolean;
}) => {
  const selectedValue = pathways.some(pathway => pathway.id === value) ? value : undefined;
  return <ConfigProvider theme={{
    components: {
      Select: {
        colorTextPlaceholder: "var(--color-gray-800)",
        controlPaddingHorizontal: 4,
        // colorBorder: "transparent",
        // activeBorderColor: "transparent",
        // hoverBorderColor: "transparent",
        activeOutlineColor: "transparent",
        paddingContentHorizontal: 0,
        controlPaddingHorizontalSM: 0
      }
    }
  }} data-sentry-element="ConfigProvider" data-sentry-component="PathwaySelector" data-sentry-source-file="PathwaySelector.tsx">
      <div className="flex items-center gap-1">
        <Select className="min-w-50 font-semibold" value={selectedValue} placeholder={placeholder} allowClear={false} suffixIcon={<CaretDownIcon fill="bold" className="text-base text-gray-800" />} options={pathways.map(({
        id,
        adaptation_type
      }) => ({
        label: <AdaptationTag type={adaptation_type} />,
        value: id
      }))} onChange={selected => handleSelect(selected ?? null)} data-sentry-element="Select" data-sentry-source-file="PathwaySelector.tsx" />
        {allowClear && value && <Button type="text" size="small" className="px-1 text-xs text-gray-700" onClick={() => handleSelect(null)}>
            <CloseCircleFilled className="text-gray-400" />
          </Button>}
      </div>
    </ConfigProvider>;
};
export default PathwaySelector;